export default function stringToDate(text) {
  if (!text) {
    return null
  }

  // ISO / Y-m-d, e.g. "2026-07-15"
  if (text.indexOf('-') !== -1) {
    const parts = text.split('-')
    return new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10))
  }

  // dd/mm/yyyy, e.g. "15/07/2026"
  const parts = text.split('/')
  return new Date(parseInt(parts[2], 10), parseInt(parts[1], 10) - 1, parseInt(parts[0], 10))
}